/* CompareViewRenderer.js */

"use strict";
const _ = require("lodash");
const ComboBox = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single.Icon
    .ComboBox;
const BrowserDetect = require("@gluenetworks/srvc_core_browser-detect");
const {Diff2HtmlUI} = require("diff2html/lib/ui/js/diff2html-ui.js");
// import { Diff2HtmlUI } from 'diff2html';
const JsonDiff = require("@gluenetworks/json_diff_control").JsonDiffControlComponent;

class CompareViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("compare-view-gl"); //TODO Setup the root Element
        this._editorViewActionElem = document.querySelectorAll(
            "editor-layout-gl .focused_item game-editor-view-actions-gl left-container"
        );
        this._layoutSizeElem = undefined;
        this._layoutViewElem = undefined;
        this._rootElem.component = this._model;
        this._defaultViewActive = false;
        this._compareViewMain = document.createElement("compare-view-main");
        this._tree = document.createElement("tree-view");
        this._tree.classList.add("hidden");

        this._showTooBigMessage = _.debounce(this._showTooBigMessage.bind(this), 200);

        this._model._gameEditor._renderer._rootElem.classList.add("compare-view-game-editor");

        const treeWidth = this._model._userDataStorage.getData("treeContainerWidth", true) || 300;
        this._tree.style.width = treeWidth + "px";

        this._resizer = document.createElement("div");
        this._resizer.className = "resizer";
        this._resizer.id = "resizer";
        this._documentWidth = document.body.clientWidth;
        this._resizer.style.width = (this._documentWidth * 0.3) / 100 + "px";

        this._rootElem.appendChild(this._tree);
        this._rootElem.appendChild(this._resizer);
        this._rootElem.appendChild(this._compareViewMain);
        this.a = {};
        this.b = {};

        this._diffChangedRowElems = [];
        this._focusedRowIndex = undefined;
        this._scrollBehavior = true;
        this._viewActionsAdded = false;
        this._isEdge = BrowserDetect.browser === "Edge";
        this._onScroll = _.debounce(this._onDebouncedScroll, 150);
        this._onDiff = _.debounce(this._onDebouncedDiff, 400);
        this._onConfigList = _.debounce(this._onDebouncedConfigList, 150);
        this._updateConfiguration = this._updateConfiguration.bind(this);

        this._getIcon = (op) => {
            if (op.isStable) {
                return "common.star";
            }
            if (_.isUndefined(op.wasDifferentAtCaptureTime)) {
                return "devicemanager.discovered";
            }
            return "configdrift.snapshot";
        };

        this._resObserver = this.observeResize();

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("Diff", (this._onDiff = this._onDiff.bind(this)));
        this._model.on("ConfigList", (this._onConfigList = this._onConfigList.bind(this)));
        this._model.on("Value", (this._onValue = this._onValue.bind(this)));
        this._model.on("SizeChanged", (this._setHeight = this._setHeight.bind(this)));
        this._resizer.addEventListener(
            "mousedown",
            (this._onResizerMousedown = this._onResizerMousedown.bind(this))
        );
        window.addEventListener(
            "resize",
            (this._onWindowResize = () => {
                this._documentWidth = document.body.clientWidth;
                const treeWidth =
                    this._model._userDataStorage.getData("treeContainerWidth", true) || 300;
                this._tree.style.width = treeWidth + "px";
                const bottomBar = this._model._gameEditor._viewActionsCmpnt._renderer._rootElem;

                bottomBar.style.marginLeft = this._tree.offsetWidth + "px";
            })
        );
    }

    _unregisterListeners() {
        this._model.removeListener("Diff", this._onDiff);
        this._model.removeListener("Value", this._onConfigList);
        this._model.removeListener("ConfigList", this._onConfigList);
        this._model.removeListener("SizeChanged", this._setHeight);
        if (this.jsonDiff) {
            this.jsonDiff.removeListener("JsonDiffNoDiff", this._hideJsonDiff);
            this.jsonDiff.removeListener("JsonDiffHasDiff", this._showJsonDiff);
        }
        this._resizer.removeEventListener("mousedown", this._onResizerMousedown);
        window.removeEventListener("resize", this._onWindowResize);
    }

    _registerViewModeButtonListeners() {
        this._setCompactBtn.addEventListener(
            "click",
            (this._onActionViewTypeClick = this._onActionViewTypeClick.bind(this))
        );
        this._setExpandedBtn.addEventListener(
            "click",
            (this._onActionViewTypeClick = this._onActionViewTypeClick.bind(this))
        );
        this._setSideBySideBtn.addEventListener(
            "click",
            (this._onActionViewTypeClick = this._onActionViewTypeClick.bind(this))
        );
        this._setLineByLineBtn.addEventListener(
            "click",
            (this._onActionViewTypeClick = this._onActionViewTypeClick.bind(this))
        );
    }

    _unregisterViewModeButtonListeners() {
        this._setCompactBtn.removeEventListener("click", this._onActionViewTypeClick);
        this._setExpandedBtn.removeEventListener("click", this._onActionViewTypeClick);
        this._setSideBySideBtn.removeEventListener("click", this._onActionViewTypeClick);
        this._setLineByLineBtn.removeEventListener("click", this._onActionViewTypeClick);
    }

    _onValue(side, op) {
        if (!_.isEqual(this[side].optionsComboBox.value, op)) {
            this[side].optionsComboBox.setValue(op);
        }
    }
    _onActionViewTypeClick(val) {
        switch (val.currentTarget.title) {
            case "Compact View":
                this._setViewType(true, this._model._viewMode._layoutView);
                break;
            case "Expanded View":
                if (this._model._diffTooLarge) {
                    const opts = {
                        title: "Comparison too large to display",
                        confirmDetails: {text: "Yes", type: "text"},
                        rejectDetails: {text: "No", type: "destructive"},
                    };
                    let msg =
                        "Displaying this large comparison may take time. To reduce time, select a specific command or download the comparison file. \n\n";
                    msg += "Are you sure you want to continue?";
                    this._model._modalUserFeedback
                        .displayConfirmation(msg, opts)
                        .then(() => {
                            this._model._isExpandedLargeDiff = true;
                            return this._setViewType(false, this._model._viewMode._layoutView);
                        })
                        .catch((err) =>
                            this._model._logger.warn(
                                {error: err},
                                "CompareViewRenderer: failed to display large diff confirmation"
                            )
                        );
                } else {
                    this._setViewType(false, this._model._viewMode._layoutView);
                }
                break;
            case "Side by Side View":
                this._setViewType(this._model._viewMode._setCompactBtn, "side-by-side");
                break;
            case "Line by Line View":
                this._setViewType(this._model._viewMode._setCompactBtn, "line-by-line");
                break;
        }
    }

    _onDebouncedConfigList() {
        let ops = this._model.getOptions();
        ["a", "b"].forEach((side) => {
            this[side].optionsComboBox.setOptions(ops);
            let sel = this._model.getValue(side);
            this[side].optionsComboBox.value = sel;
        });
    }
    observeResize() {
        const resObs = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.contentRect && this._model) {
                    this._model.emit("SizeChanged");
                }
            });
        });
        return resObs;
    }

    async _onDebouncedDiff() {
        const genAtStart = this._model._diffGenerationCount;
        this._renderCompareOptions();
        await this._renderDiff(...arguments);
        this._renderBroThumbs();
        this._renderNavBar();

        this._hideShowJSONButton();

        if (genAtStart === this._model._diffGenerationCount && this._model._isDiffReady) {
            return this._model._modalUserFeedback.hideDisplayed();
        }
    }

    _renderBroThumbs() {
        this._removeBroThumbs();
        let aVal = this._model.getValue("a");
        let bVal = this._model.getValue("b");
        if (aVal && !aVal.isStable && this.a.diffContainer) {
            this.a.thumbsUpBroElem = document.createElement("actionable-icon-gl");
            this.a.thumbsUpBroElem.dataset.icon = "common.star";
            this.a.thumbsUpBroElem.classList.add("make-default-icon", "a");
            this.a.thumbsUpBroElem.setAttribute("title", "Set Default Configuration");
            this.a.thumbsUpBroElem.addEventListener(
                "click",
                (this._uClickedABro = this._uClickedABro.bind(this))
            );
            this.a.diffContainer.appendChild(this.a.thumbsUpBroElem);
        }
        if (bVal && !bVal.isStable && this.b.diffContainer) {
            this.b.thumbsUpBroElem = document.createElement("actionable-icon-gl");
            this.b.thumbsUpBroElem.dataset.icon = "common.star";
            this.b.thumbsUpBroElem.classList.add("make-default-icon", "b");
            this.b.thumbsUpBroElem.setAttribute("title", "Set Default Configuration");
            this.b.thumbsUpBroElem.addEventListener(
                "click",
                (this._uClickedBBro = this._uClickedBBro.bind(this))
            );
            this.b.diffContainer.appendChild(this.b.thumbsUpBroElem);
        }
    }

    _removeBroThumbs() {
        if (_.get(this.a, "thumbsUpBroElem")) {
            this.a.thumbsUpBroElem.removeEventListener("click", this._uClickedABro);
            this.a.thumbsUpBroElem.remove();
            this.a.thumbsUpBroElem = undefined;
        }
        if (_.get(this.b, "thumbsUpBroElem")) {
            this.b.thumbsUpBroElem.removeEventListener("click", this._uClickedABro);
            this.b.thumbsUpBroElem.remove();
            this.b.thumbsUpBroElem = undefined;
        }
    }

    _renderCompareOptions() {
        if (!this._optionsContainerElem) {
            this._optionsContainerElem = document.createElement("options-container-gl");
            this.a.optionsContainerElem = document.createElement("a-options-container-gl");
            this.b.optionsContainerElem = document.createElement("b-options-container-gl");

            // A COMBO BOX
            this.a.optionsComboBox = new ComboBox({
                optionIcon: this._getIcon,
                selectedOptionIcon: this._getIcon,
                adjustWidth: false,
            });
            this.a.optionsComboBox.on(
                "UserValue",
                (this._onAComboBoxUserValue = this._onAComboBoxUserValue.bind(this))
            );
            this.a.optionsComboBox.renderer.rootElement.classList.add("a-side-gl");
            this.a.optionsContainerElem.appendChild(this.a.optionsComboBox.renderer.rootElement);

            // B COMBO BOX
            this.b.optionsComboBox = new ComboBox({
                optionIcon: this._getIcon,
                selectedOptionIcon: this._getIcon,
                adjustWidth: false,
            });
            this.b.optionsComboBox.on(
                "UserValue",
                (this._onBComboBoxUserValue = this._onBComboBoxUserValue.bind(this))
            );
            this.b.optionsComboBox.renderer.rootElement.classList.add("b-side-gl");
            this.b.optionsContainerElem.appendChild(this.b.optionsComboBox.renderer.rootElement);

            // CONTAINERS
            this._optionsContainerElem.appendChild(this.a.optionsContainerElem);
            this._optionsContainerElem.appendChild(this.b.optionsContainerElem);
            this._compareViewMain.appendChild(this._optionsContainerElem);
        }

        let ops = this._model.getOptions();
        if (_.isEmpty(ops)) {
            this.a.optionsComboBox.setDisabled(true);
            this.b.optionsComboBox.setDisabled(true);
        } else {
            this.a.optionsComboBox.setOptions(ops);
            this.b.optionsComboBox.setOptions(ops);
        }
        let as = this._model.getValue("a");
        let bs = this._model.getValue("b");
        if (as) {
            this.a.optionsComboBox.setValue(as);
        }
        if (bs) {
            this.b.optionsComboBox.setValue(bs);
        }
    }

    _removeCompareOptions() {
        if (this._optionsContainerElem) {
            let promArr = [this.a.optionsComboBox.shutdown(), this.b.optionsComboBox.shutdown()];

            return Promise.resolve(promArr)
                .then(() => {
                    this.a.optionsContainerElem.remove();
                    this.a.optionsContainerElem = undefined;
                    this.a = {};
                    // B
                    this.b.optionsContainerElem.remove();
                    this.b.optionsContainerElem = undefined;
                    this.b = {};
                    // container
                    this._optionsContainerElem.remove();
                    this._optionsContainerElem = undefined;
                })
                .catch((err) => {
                    this.model._logger.warn(
                        {error: err},
                        "CompareViewRenderer._removeCompareOptions() error."
                    );
                });
        } else {
            return Promise.resolve();
        }
    }

    async _onAComboBoxUserValue(value) {
        await this._model.setValues(...this._getABValues(value, "a"));
        this._generateTree();
    }

    async _onBComboBoxUserValue(value) {
        await this._model.setValues(...this._getABValues(value, "b"));
        this._generateTree();
    }

    _getABValues(val, comboBox = "b") {
        // setting default logic assuming selected is b side
        let a = null,
            b = null;
        if (comboBox === "a") {
            a = val;
            const bVal = this.b.optionsComboBox.getValue();
            if (bVal.id === val.id) {
                if (bVal.isStable) {
                    b = this._model._deviceConfigs[0].value;
                } else {
                    b = this._model._stableConf.value;
                }
            }
        } else {
            b = val;
            const aVal = this.a.optionsComboBox.getValue();
            if (aVal.id === val.id) {
                if (aVal.isStable) {
                    a = this._model._deviceConfigs[0].value;
                } else {
                    a = this._model._stableConf.value;
                }
            }
        }

        return [a, b];
    }

    _renderNavBar() {
        if (!this._infoElem) {
            this._infoElem = document.createElement("nav-bar-container-gl");
            this._compareViewMain.appendChild(this._infoElem);
        }

        if (this._model._diffTooLarge) {
            this._infoElem.classList.add("hidden");
        } else {
            this._infoElem.classList.remove("hidden");
        }

        let diff = this._model.getDiffString();
        if (_.isEmpty(diff)) {
            return;
        }

        if (!_.isEmpty(this._diffChangedRowElems)) {
            this._hideDefaultMessageDisplay();
            if (this._contentIdenticalElem) {
                this._contentIdenticalElem.remove();
                this._contentIdenticalElem = undefined;
                this._contentIdenticalIcon.remove();
                this._contentIdenticalIcon = undefined;
            }

            // PREV
            if (!this._prevElem) {
                this._prevElem = document.createElement("actionable-icon-gl");
                this._prevElem.dataset.icon = "common.chevron";
                this._prevElem.classList.add("previous-icon");
                this._prevElem.addEventListener("click", (this._onPrev = this._onPrev.bind(this)));
                this._infoElem.appendChild(this._prevElem);
            }

            // FOCUS INDEX
            if (!this._focusInfoElem) {
                this._focusInfoElem = document.createElement("diff-focus-info-gl");
                this._infoElem.appendChild(this._focusInfoElem);
            }

            // NEXT
            if (!this._nextElem) {
                this._nextElem = document.createElement("actionable-icon-gl");
                this._nextElem.dataset.icon = "common.chevron";
                this._nextElem.classList.add("next-icon");
                this._nextElem.addEventListener("click", (this._onNext = this._onNext.bind(this)));
                this._infoElem.appendChild(this._nextElem);
            }

            // LINE NUMBER
            if (!this._lineNumElem) {
                this._lineNumElem = document.createElement("diff-line-num-gl");
                this._infoElem.appendChild(this._lineNumElem);
            }

            let changeCount = this._diffChangedRowElems.length;
            this._focusInfoElem.innerHTML = this._diffChangedRowElems.length + " changes";
            if (_.isNumber(this._focusedRowIndex)) {
                this._focusInfoElem.innerHTML = this._focusedRowIndex + 1 + "/" + changeCount;
                let rowEl = this._diffChangedRowElems[this._focusedRowIndex];
                let lineNum =
                    this.model.viewMode.layoutView === "side-by-side"
                        ? rowEl.querySelector(".d2h-code-side-linenumber").innerHTML
                        : rowEl.querySelector(".d2h-code-linenumber").innerHTML;
                this._lineNumElem.innerHTML = "line " + lineNum;
            } else {
                this._focusInfoElem.innerHTML = "0/" + changeCount;
                this._lineNumElem.innerHTML = "";
            }
        } else {
            if (this._prevElem) {
                this._prevElem.remove();
                this._prevElem = undefined;
                this._nextElem.remove();
                this._nextElem = undefined;
                this._focusInfoElem.remove();
                this._focusInfoElem = undefined;
                this._lineNumElem.remove();
                this._lineNumElem = undefined;
            }
            this._removeDiff();
        }
    }

    _removeNavBar() {
        if (this._infoElem) {
            this._infoElem.remove();
            this._infoElem = undefined;
        }
    }

    /**
     * Syncing Scroll bars:
     * A hack put in place until we can create our own Diff Renderer Component.
     * The reason is scroll sync no longer works when we override the default styles to get horizontal scroll bars
     * visible within the app, instead of having to scroll to the bottom to get access to them.
     * @private
     */

    _syncScrolling() {
        this._d2h_code_wrapper_elems =
            this._compareViewMain.querySelectorAll(".d2h-file-side-diff");
        if (!_.isEmpty(this._d2h_code_wrapper_elems)) {
            this._d2h_code_wrapper_elems.forEach((el) => {
                el.addEventListener("scroll", (this._onScroll = this._onScroll.bind(this)));
            });
            // lets hide the thumbs up icon while scrolling as it drags and looks odd
            this._d2h_code_wrapper_elems.forEach((el) => {
                el.addEventListener(
                    "scroll",
                    (this._handleBroThumbs = this._handleBroThumbs.bind(this))
                );
            });
        }
    }

    _handleBroThumbs(evt) {
        let st = evt.target.scrollTop;
        let sl = evt.target.scrollLeft;
        let thumbsUpBroBottomOffset = 10 - st + "px";
        let thumbsUpBroLeftOffset = 10 - sl + "px";
        if (this.a.thumbsUpBroElem) {
            this.a.thumbsUpBroElem.style.bottom = thumbsUpBroBottomOffset;
            this.a.thumbsUpBroElem.style.right = thumbsUpBroLeftOffset;
        }
        if (this.b.thumbsUpBroElem) {
            this.b.thumbsUpBroElem.style.bottom = thumbsUpBroBottomOffset;
            this.b.thumbsUpBroElem.style.right = thumbsUpBroLeftOffset;
        }
    }

    _onDebouncedScroll(evt) {
        let st = evt.target.scrollTop;
        let sl = evt.target.scrollLeft;
        this._d2h_code_wrapper_elems.forEach((el) => {
            if (!_.isEqual(el.scrollTop, st)) {
                el.scrollTop = st;
            }
            if (!_.isEqual(el.scrollLeft, sl)) {
                el.scrollLeft = sl;
            }
        });
    }

    async _renderDiff() {
        let ds = this._model.getDiffString();
        this._model._diffTooLarge = false;
        if (
            !this._model._jsonDiff &&
            ds &&
            ds.split("\n").length > 20000 &&
            !this._model._isExpandedLargeDiff
        ) {
            this._model._diffTooLarge = true;
        }
        this._model._isExpandedLargeDiff = false;
        this._displayDiff(ds);
        return Promise.resolve();
    }
    _showTooBigMessage() {
        this._showConfigTooBigMessageDisplay();
        this._addViewActions();
        this._setActiveButton(this.model.viewMode.compactView, this.model.viewMode.layoutView);
    }
    _displayDiff(ds) {
        this._removeDiff();
        if (!this._model._jsonDiff) {
            this._jConfigContainerElem && this._jConfigContainerElem.remove();
            this._configContainerElem = document.createElement("compare-container-gl");
            this._configContainerElem.setAttribute(
                "class",
                this.model.viewMode.compactView === true || this._model._diffTooLarge
                    ? "compactView"
                    : "fullView"
            );
            if (this.model.viewMode.layoutView === "line-by-line") {
                this._configContainerElem.classList.add("line_by_line");
            }

            this._compareViewMain.appendChild(this._configContainerElem);

            if (!_.isEmpty(ds)) {
                if (this._model._diffTooLarge) {
                    if (!this.model.viewMode.compactView) {
                        this.model.viewMode.setViewProps(true, this.model.viewMode.layoutView);
                    } else {
                        if (!this._model._isDiffReady) {
                            this._model._isDiffReady = true;
                            this._model._modalUserFeedback.hideDisplayed();
                        }
                        this._showTooBigMessage();
                    }
                    return;
                }
                const config = {
                    synchronisedScroll: false,
                    matching: "none",
                    outputFormat: this.model.viewMode.layoutView,
                    showFiles: false,
                    matchingMaxComparisons: 1000,
                    drawFileList: false,
                };
                const targetElement = this._configContainerElem;
                const diff2htmlUi = new Diff2HtmlUI(targetElement, ds, config);
                diff2htmlUi.draw();

                this._findAndAggregateChangedRows();
                if (!_.isEmpty(this._diffChangedRowElems) && !this._model._isDiffReady) {
                    this._model._isDiffReady = true;
                    this._model._modalUserFeedback.hideDisplayed();
                }
                this._addViewActions();
                this._syncScrolling();
                let sideDiffContainers =
                    this._configContainerElem.querySelectorAll(".d2h-file-side-diff");
                if (!_.isEmpty(sideDiffContainers) && !_.isEmpty(this._diffChangedRowElems)) {
                    this.a.diffContainer = sideDiffContainers[0];
                    this.b.diffContainer = sideDiffContainers[1];
                }
                this._setActiveButton();
            } else {
                this._removeViewActions();
            }

            if (_.isEmpty(this._diffChangedRowElems) && !_.isUndefined(ds)) {
                //Check if the difflines are 0 but the whole entity is not undefined i.e. Identical
                this._removeViewActions();
                this._configContainerElem.remove();
                // Fallback: real configs were compared but produced no visible diff rows — unblock the veil
                if (!this._model._isDiffReady && this._model._confA && this._model._confB) {
                    this._model._isDiffReady = true;
                    this._model._modalUserFeedback.hideDisplayed();
                }
            }
            this._model._gameEditor._renderer._rootElem.classList.remove("json-compare-view");

            /* add the extra tr to show the vertical bar */
            const tableTbodyElems = this._configContainerElem.querySelectorAll("table tbody");
            if (tableTbodyElems) {
                tableTbodyElems.forEach((eachTbody) => {
                    const newTr = document.createElement("tr");
                    newTr.classList.add("just-the-bar");
                    eachTbody.insertBefore(newTr, eachTbody.firstChild);
                });
            }
        } else {
            this._configContainerElem && this._configContainerElem.remove();
            if (!this._jConfigContainerElem) {
                this._jConfigContainerElem = document.createElement("json-compare-container-gl");
                this._compareViewMain.appendChild(this._jConfigContainerElem);
                this._jConfigContainerElem.appendChild(this.jsonDiff.renderer._rootElement);
            }
            this.jsonDiff.setHeight(this._compareViewMain.clientHeight - 70);
            this._resObserver.observe(this._compareViewMain);
            this._model._confA = _.get(
                this.objA,
                `capture.${this._model._selectedPath}.responseObj`,
                {}
            );
            this._model._confB = _.get(
                this.objB,
                `capture.${this._model._selectedPath}.responseObj`,
                {}
            );
            // _.set(this._model._value, "a.config.confObj", JSON.stringify(aconf, null, 2));
            // _.set(this._model._value, "b.config.confObj", JSON.stringify(bconf, null, 2));
            // let a_config = _.get(this._model._value, "a.config.confObj", "{}");
            // let b_config = _.get(this._model._value, "b.config.confObj", "{}");
            this.jsonDiff.setFirstJson(this._model._confA);
            this.jsonDiff.setSecondJson(this._model._confB);
            this._model._gameEditor._renderer._rootElem.classList.add("json-compare-view");
        }
    }

    _removeDiff() {
        if (this._configContainerElem) {
            this._diffUi = undefined;
            this._configContainerElem.remove();
            this._configContainerElem = undefined;
            _.set(this.a, "diffContainer", undefined);
            _.set(this.b, "diffContainer", undefined);
        }
    }

    _addViewActions() {
        if (!this._viewActionsAdded) {
            let _actionElem = false;

            if ((_actionElem = _.get(this._editorViewActionElem, 0, false))) {
                _actionElem.classList.add("compare-icons");
                this._layoutSizeElem = document.createElement("layout-size");
                _actionElem.appendChild(this._layoutSizeElem);
                this._setCompactBtn = document.createElement("actionable-icon-gl");
                this._setCompactBtn.dataset.icon = "configdrift.compare_compact";
                this._setCompactBtn.setAttribute("title", "Compact View");
                this._layoutSizeElem.appendChild(this._setCompactBtn);

                this._setExpandedBtn = document.createElement("actionable-icon-gl");
                this._setExpandedBtn.dataset.icon = "configdrift.compare_expanded";
                this._setExpandedBtn.setAttribute("title", "Expanded View");
                this._layoutSizeElem.appendChild(this._setExpandedBtn);

                this._layoutViewElem = document.createElement("layout-view");
                _actionElem.appendChild(this._layoutViewElem);

                this._setSideBySideBtn = document.createElement("actionable-icon-gl");
                this._setSideBySideBtn.dataset.icon = "configdrift.compare_side_by_side";
                this._setSideBySideBtn.setAttribute("title", "Side by Side View");
                this._layoutViewElem.appendChild(this._setSideBySideBtn);

                this._setLineByLineBtn = document.createElement("actionable-icon-gl");
                this._setLineByLineBtn.dataset.icon = "configdrift.compare_line_by_line";
                this._setLineByLineBtn.setAttribute("title", "Line by Line View");
                this._layoutViewElem.appendChild(this._setLineByLineBtn);

                this._registerViewModeButtonListeners();
            }

            this.model.gameEditor.addViewAction({
                type: "normal",
                displayName: "JSON",
                name: "switchView",
                position: "left",
                handler: (this._switchViewType = this._switchViewType.bind(this)),
            });

            this.model.gameEditor.addViewAction({
                type: "normal",
                displayName: "Download",
                name: "DownloadDiffs",
                handler: (this._onDownloadConfigDiffs = this._onDownloadConfigDiffs.bind(this)),
            });

            this._viewActionsAdded = true;
        }
    }

    _setViewType(isCompactView, viewType) {
        this.model.viewMode.setViewProps(isCompactView, viewType);
        this._setActiveButton(isCompactView, viewType);
    }

    _setActiveButton(isCompactBtn = undefined, viewTypeBtn = undefined) {
        if (![isCompactBtn, viewTypeBtn].every((i) => i === undefined)) {
            if (isCompactBtn) {
                _.get(
                    this._layoutSizeElem.querySelectorAll(
                        "actionable-icon-gl[title='Compact View']"
                    ),
                    0
                ).classList.add("active");
                _.get(
                    this._layoutSizeElem.querySelectorAll(
                        "actionable-icon-gl[title='Expanded View']"
                    ),
                    0
                ).classList.remove("active");
            } else {
                _.get(
                    this._layoutSizeElem.querySelectorAll(
                        "actionable-icon-gl[title='Expanded View']"
                    ),
                    0
                ).classList.add("active");
                _.get(
                    this._layoutSizeElem.querySelectorAll(
                        "actionable-icon-gl[title='Compact View']"
                    ),
                    0
                ).classList.remove("active");
            }

            if (viewTypeBtn === "side-by-side") {
                _.get(
                    this._layoutViewElem.querySelectorAll(
                        "actionable-icon-gl[title='Side by Side View']"
                    ),
                    0
                ).classList.add("active");
                _.get(
                    this._layoutViewElem.querySelectorAll(
                        "actionable-icon-gl[title='Line by Line View']"
                    ),
                    0
                ).classList.remove("active");
            } else {
                _.get(
                    this._layoutViewElem.querySelectorAll(
                        "actionable-icon-gl[title='Line by Line View']"
                    ),
                    0
                ).classList.add("active");
                _.get(
                    this._layoutViewElem.querySelectorAll(
                        "actionable-icon-gl[title='Side by Side View']"
                    ),
                    0
                ).classList.remove("active");
            }
        } else {
            this._setActiveButton(
                this._model._viewMode._compactView,
                this._model._viewMode._layoutView
            );
        }
    }

    _removeViewActions() {
        if (this._viewActionsAdded) {
            this.model.gameEditor.clearViewActions();
            this._viewActionsAdded = false;
            this._hasSwitchAction = false;
        }
    }

    _downloadConfigDiffs(diff, fileExt = "txt", type = "text/plain") {
        let aConf = "";
        let bConf = "";
        let _diff = diff || this.model.getDiffString();
        let aFileName = this._filterName(this.a.optionsComboBox.value.name);
        let bFileName = this._filterName(this.b.optionsComboBox.value.name);
        let fileConfig = {};

        if (!this._model._jsonDiff) {
            aConf = _.get(this._model, "_confA", "");
            bConf = _.get(this._model, "_confB", "");
        } else {
            aConf = JSON.stringify(_.get(this._model, "_confA", "{}"), null, 2);
            bConf = JSON.stringify(_.get(this._model, "_confB", "{}"), null, 2);
        }

        fileConfig[aFileName + "." + fileExt] = {
            type,
            content: aConf,
        };
        fileConfig[bFileName + "." + fileExt] = {
            type,
            content: bConf,
        };
        fileConfig["diff." + fileExt] = {
            type,
            content: _diff,
        };

        let fileName = this._filterName(this.model.deviceName) + "_File_Comparison.zip";
        return this.model.io.fileFactory.saveStringsAsZip(fileConfig, fileName);
    }

    _onDownloadConfigDiffs() {
        this.model.gameEditor.disableViewAction("DownloadDiffs");
        this._downloadConfigDiffs().finally(() => {
            this.model.gameEditor.enableViewAction("DownloadDiffs");
        });
    }

    _switchViewType() {
        if (this._jConfigContainerElem) {
            this._jConfigContainerElem.remove();
            this._jConfigContainerElem = undefined;
        }
        this._model._isJsonView = !this._model._isJsonView;
        // let viewType = this._model._viewType;
        if (this._model._isJsonView) {
            this._model._viewType = "json";
            this._model._jsonDiff = true;
            this._model._userDataStorage.setData("json", "viewType");
            this._updateConfiguration(this._model._selectedPath);
        } else {
            this._model._jsonDiff = false;
            this._model._viewType = "text";
            this._model._userDataStorage.setData("text", "viewType");
            this._updateConfiguration(this._model._selectedPath);
        }
    }

    _filterName(name) {
        return name.replace(/\s|:|\*|-|\/|\\/g, "_");
    }

    _onNext() {
        if (!_.isEmpty(this._diffChangedRowElems)) {
            if (_.isNumber(this._focusedRowIndex)) {
                this._diffChangedRowElems[this._focusedRowIndex].classList.remove("focused");
                if (this._focusedRowIndex < this._diffChangedRowElems.length - 1) {
                    this._focusedRowIndex++;
                } else {
                    this._focusedRowIndex = 0;
                }
            } else {
                this._focusedRowIndex = 0;
            }
            if (_.isNumber(this._focusedRowIndex)) {
                let rowElem = this._diffChangedRowElems[this._focusedRowIndex];
                rowElem.classList.add("focused");
                if (this._isEdge) {
                    rowElem.scrollIntoView(this._scrollBehavior);
                } else {
                    rowElem.focus();
                }
            }
        }
        this._renderNavBar();
    }

    _onPrev() {
        if (!_.isEmpty(this._diffChangedRowElems)) {
            if (_.isNumber(this._focusedRowIndex)) {
                this._diffChangedRowElems[this._focusedRowIndex].classList.remove("focused");
                if (this._focusedRowIndex > 0) {
                    this._focusedRowIndex--;
                } else {
                    this._focusedRowIndex = this._diffChangedRowElems.length - 1;
                }
            } else {
                this._focusedRowIndex = this._diffChangedRowElems.length - 1;
            }

            let rowElem = this._diffChangedRowElems[this._focusedRowIndex];
            rowElem.classList.add("focused");
            if (this._isEdge) {
                rowElem.scrollIntoView(this._scrollBehavior);
            } else {
                rowElem.focus();
            }
        }
        this._renderNavBar();
    }

    _findAndAggregateChangedRows() {
        this._focusedRowIndex = undefined;
        this._diffChangedRowElems = [];
        let tableTbodyElems = this._configContainerElem.querySelectorAll("table tbody");
        if (!_.isEmpty(tableTbodyElems)) {
            this.a.rowElems = tableTbodyElems[0].querySelectorAll("tr");
            this.b.rowElems =
                this.model.viewMode.layoutView === "side-by-side"
                    ? tableTbodyElems[1].querySelectorAll("tr")
                    : [];
            let query = ".d2h-change, .d2h-del, .d2h-ins";
            if (!_.isEmpty(this.b.rowElems) && this.model.viewMode.layoutView === "side-by-side") {
                let lastRowFocused = {a: false, b: false}; // we only want the first row within a group of changes. Otherwise each row is treated like a unique change.
                _.each(this.a.rowElems, (a_row, idx) => {
                    let aChangedRow = a_row.querySelector(query);
                    let b_row = this.b.rowElems[idx];
                    let bChangedRow = b_row.querySelector(query);
                    if (aChangedRow) {
                        if (!lastRowFocused.a) {
                            a_row.setAttribute("tabindex", -1);
                            a_row._glSide = "a";
                            this._diffChangedRowElems.push(a_row);
                        }
                    } else if (bChangedRow) {
                        if (!lastRowFocused.b) {
                            b_row.setAttribute("tabindex", -1);
                            b_row._glSide = "b";
                            this._diffChangedRowElems.push(b_row);
                        }
                    }
                    if (aChangedRow) {
                        lastRowFocused.a = true;
                    } else {
                        lastRowFocused.a = false;
                    }
                    if (bChangedRow) {
                        lastRowFocused.b = true;
                    } else {
                        lastRowFocused.b = false;
                    }
                });
            } else if (this.model.viewMode.layoutView === "line-by-line") {
                _.each(this.a.rowElems, (a_row) => {
                    let aChangedRow = a_row.querySelector(query);
                    if (aChangedRow) {
                        a_row.setAttribute("tabindex", -1);
                        a_row._glSide = "a";
                        this._diffChangedRowElems.push(a_row);
                    }
                });
            }
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._hideDefaultMessageDisplay();
        this._model._gameEditor._renderer._rootElem.classList.remove("json-compare-view");

        const bottomBar = this._model._gameEditor._viewActionsCmpnt._renderer._rootElem;
        bottomBar.removeAttribute("style");
        this._model._gameEditor._renderer._rootElem.classList.remove("compare-view-game-editor");

        this._unregisterListeners();
        this._resObserver.unobserve(this._compareViewMain);
        if (
            ![
                this._setCompactBtn,
                this._setExpandedBtn,
                this._setSideBySideBtn,
                this._setLineByLineBtn,
            ].every(undefined)
        ) {
            this._unregisterViewModeButtonListeners();
        }
        let promArr = [this._removeCompareOptions()];

        return Promise.all(promArr).then(
            () => {
                this._tree.remove();
                this._resizer.remove();
                this._compareViewMain.remove();
                this._rootElem.remove();

                this.a = undefined;
                this.b = undefined;
                this._defaultViewActive = undefined;
                this._editorViewActionElem = undefined;
                this._layoutSizeElem = undefined;
                this._layoutViewElem = undefined;
                this._removeBroThumbs();
                this._removeDiff();
                this._removeNavBar();
                this._model = undefined;
                this._compareViewMain.remove();
                this._compareViewMain = undefined;
                if (
                    ![
                        this._setCompactBtn,
                        this._setExpandedBtn,
                        this._setSideBySideBtn,
                        this._setLineByLineBtn,
                    ].every(undefined)
                ) {
                    this._setCompactBtn = undefined;
                    this._setExpandedBtn = undefined;
                    this._setSideBySideBtn = undefined;
                    this._setLineByLineBtn = undefined;
                }
            },
            (err) => {
                this.model._logger.warn({error: err}, "CompareViewRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model
            .whenModelIsReady()
            .then(() => {
                return this._generateTree();
            })
            .then(() => {
                const bottomBar = this._model._gameEditor._viewActionsCmpnt._renderer._rootElem;
                bottomBar.style.marginLeft = this._tree.offsetWidth + "px";

                this.jsonDiff = new JsonDiff({
                    theme: "light",
                    context: this,
                    downloadCB: this._downloadConfigDiffs.bind(this),
                    actions: {
                        switchView: {
                            name: "switchView",
                            display: "Text",
                            cb: this._switchViewType.bind(this),
                            position: "left",
                        },
                    },
                });

                this.jsonDiff.on(
                    "JsonDiffNoDiff",
                    (this._hideJsonDiff = this._hideJsonDiff.bind(this))
                );
                this.jsonDiff.on(
                    "JsonDiffHasDiff",
                    (this._showJsonDiff = this._showJsonDiff.bind(this))
                );
                this._rootElem.setAttribute("id", this.model.id);
            });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    // TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _setHeight() {
        this.jsonDiff.setHeight(this._compareViewMain.clientHeight - 70);
    }

    _onDisplayMode() {
        const isCompactView = this.model.viewMode.compactView,
            currentLayoutView = this.model.viewMode.layoutView;
        if (isCompactView === true) {
            this.model.viewMode.setViewProps(
                !isCompactView,
                currentLayoutView === "line-by-line"
                    ? "side-by-side"
                    : currentLayoutView === "side-by-side"
                    ? "line-by-line"
                    : currentLayoutView
            );
        } else {
            this.model.viewMode.setViewProps(!isCompactView);
        }
    }

    _uClickedABro(/*event*/) {
        let activeSelection = this.a.optionsComboBox.getValue();
        if (!_.isUndefined(activeSelection) && !_.isUndefined(activeSelection.id)) {
            this._onSetDefaultSnapshotConfirm(activeSelection);
        }
    }

    _uClickedBBro(/*event*/) {
        let activeSelection = this.b.optionsComboBox.getValue();
        if (!_.isUndefined(activeSelection) && !_.isUndefined(activeSelection.id)) {
            this._onSetDefaultSnapshotConfirm(activeSelection);
        }
    }

    _onSetDefaultSnapshotConfirm(snapshot) {
        this.model.gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: `Set Configuration Snapshot ${snapshot.name} as new default?`,
                title: "Set Default Configuration",
                confirmDetails: {
                    text: "Confirm",
                    type: "additive",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            },
            () => {
                return this._model.makeDefaultSnapshot(snapshot.id);
            }
        );
    }

    _onResizerMousedown(e) {
        let treeWidth = this._tree.style.width;
        const bottomBar = this._model._gameEditor._viewActionsCmpnt._renderer._rootElem;

        e = e || window.event;
        let start = 0,
            diff = 0;
        if (e.pageX) {
            start = e.pageX;
        } else if (e.clientX) {
            start = e.clientX;
        }

        document.body.onmousemove = (e) => {
            e = e || window.event;
            let end = 0;
            if (e.pageX) {
                end = e.pageX;
            } else if (e.clientX) {
                end = e.clientX;
            }

            diff = end - start;
            let updatedTreeWidth = this._tree.style.width;
            if (parseInt(updatedTreeWidth, 10) > 100 || diff > 0) {
                this._tree.style.width = parseInt(treeWidth, 10) + diff + "px";
                bottomBar.style.marginLeft = this._tree.offsetWidth + "px";
            }
        };
        document.body.onmouseup = () => {
            this._model._userDataStorage.setData(
                parseInt(this._tree.style.width, 10),
                "treeContainerWidth"
            );
            bottomBar.style.marginLeft = this._tree.offsetWidth + "px";
            document.body.onmousemove = document.body.onmouseup = null;
        };
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _showDefaultMessageDisplay() {
        this._model.gameEditor
            .showDefaultMessageView({
                message: "No configuration snapshot available",
            })
            .then(() => {
                this._defaultViewActive = true;
            });
        this._rootElem.parentNode.classList.add("no-comparison");

        const messageRootElement = _.get(
            this._model.gameEditor._defaultMessageViewCmpnt,
            "_renderer._rootElem",
            false
        );
        if (messageRootElement) {
            this._compareViewMain.append(messageRootElement);
        }
    }

    _showDeviceIdenticalMessageDisplay() {
        this._model.gameEditor
            .showDefaultMessageView({
                message: "Configuration snapshots are the same",
                icon: "configdrift.same",
            })
            .then(() => {
                this._defaultViewActive = true;
            });
        this._rootElem.parentNode.classList.add("devices-identical");

        const messageRootElement = _.get(
            this._model.gameEditor._defaultMessageViewCmpnt,
            "_renderer._rootElem",
            false
        );
        if (messageRootElement) {
            this._compareViewMain.append(messageRootElement);
        }
    }

    _hideDefaultMessageDisplay() {
        this._model.gameEditor.hideDefaultMessageView().then(() => {
            this._defaultViewActive = false;
        });
        this._rootElem.parentNode.classList.remove("devices-identical");
        this._rootElem.parentNode.classList.remove("no-comparison");
    }

    _showConfigTooBigMessageDisplay() {
        this._model.gameEditor
            .showDefaultMessageView({
                message:
                    "Click Download for a text file of the comparison <br />that was too large to display.",
            })
            .then(() => {
                this._defaultViewActive = true;
            });
        this._rootElem.parentNode.classList.add("devices-config-too-big");

        const messageRootElement = _.get(
            this._model.gameEditor._defaultMessageViewCmpnt,
            "_renderer._rootElem",
            false
        );
        if (messageRootElement) {
            this._compareViewMain.append(messageRootElement);
        }
    }

    _hideJsonDiff() {
        if (this._jConfigContainerElem) {
            this._jConfigContainerElem.classList.add("vishidden");
            this._showDeviceIdenticalMessageDisplay();
        }
    }

    _showJsonDiff() {
        if (this._jConfigContainerElem) {
            this._jConfigContainerElem.classList.remove("vishidden");
            this._hideDefaultMessageDisplay();
        }
    }

    _generateTree() {
        const rootKey = "capture";
        this.objA = {
            capture: _.get(this._model._value, "a.capture.capture", undefined),
        };
        this.objB = {
            capture: _.get(this._model._value, "b.capture.capture", undefined),
        };

        const rootNode = this.buildTree(this.objA[rootKey], rootKey);

        if (rootNode) {
            this._tree.classList.remove("hidden");

            this._tree.innerHTML = "";
            this._tree.appendChild(rootNode);

            let initialPath = "";
            if (
                !_.get(this.objA.capture, initialPath, false) &&
                !_.get(this.objB.capture, initialPath, false)
            ) {
                initialPath = "";
            }
            this._updateConfiguration(initialPath);
            this._setSelection(initialPath);

            // Expand/Collapse functionality
            const treeNodes = this._tree.querySelectorAll(".tree-node");
            treeNodes.forEach((node) => {
                const toggleButton = node.querySelector(".toggle-button");
                if (toggleButton) {
                    toggleButton.addEventListener("click", (e) => {
                        e.stopImmediatePropagation();
                        node.classList.toggle("collapsed");
                    });
                }

                node.addEventListener("click", (e) => {
                    e.stopImmediatePropagation();
                    const path = e.currentTarget.getAttribute("data-path");

                    this._updateConfiguration(path);
                    this._setSelection(path);
                });
            });
        } else {
            this._tree.innerHTML = "";
            this._tree.classList.add("hidden");
        }
    }

    createTreeNode(label, className = "", type = undefined, path = "", level) {
        if (label) {
            const node = document.createElement("div");
            node.className = "tree-node " + className;
            node.setAttribute("data-path", path);

            if (type !== "node") {
                const toggleButton = document.createElement("button");
                toggleButton.className = "toggle-button";
                node.appendChild(toggleButton);
            }

            const span = document.createElement("span");
            if (level === "root") {
                const _iconRoot = document.createElement("base-icon-gl");
                _iconRoot.dataset.icon = "configdrift.snapshot";
                _iconRoot.classList.add("icon", "m-r-4");
                span.appendChild(_iconRoot);
            } else if (level === "folder" && label !== "Standard") {
                const _iconFolderOpen = document.createElement("base-icon-gl");
                _iconFolderOpen.dataset.icon = "fileserver.folder";
                _iconFolderOpen.classList.add("icon-open", "m-r-4");

                const _iconFolderClose = document.createElement("base-icon-gl");
                _iconFolderClose.dataset.icon = "fileserver.folder_open";
                _iconFolderClose.classList.add("icon-close", "m-r-4");

                span.appendChild(_iconFolderOpen);
                span.appendChild(_iconFolderClose);
            } else {
                const _iconFile = document.createElement("base-icon-gl");
                _iconFile.dataset.icon = "fileserver.file";
                _iconFile.classList.add("icon");

                span.appendChild(_iconFile);
            }

            const spanText = document.createElement("span");
            spanText.innerText = label;
            span.appendChild(spanText);
            node.appendChild(span);

            return node;
        }
    }

    _isEmptyCommandSet(obj) {
        for (const key in obj) {
            if (
                key !== "commandSetName" &&
                obj.hasOwnProperty(key) &&
                _.isArray(obj[key]) &&
                obj[key].length > 0
            ) {
                return false; // At least one non-empty array found
            }
        }
        return true; // All arrays are empty or no arrays found
    }

    buildTree(node, key) {
        const diffClass = this.getDiffClass(this.objA[key], this.objB[key]);
        let label = key;
        if (key === "capture") {
            label = "All";
        }
        const treeNode = this.createTreeNode(label, diffClass, undefined, undefined, "root");

        if (typeof this.objA[key] === "object" && typeof this.objB[key] === "object") {
            const subKeys = new Set([
                ...Object.keys(this.objA[key]),
                ...Object.keys(this.objB[key]),
            ]);

            for (const subKey of subKeys) {
                if (subKey === "isObject") {
                    continue;
                }

                let labelVal = subKey;
                if (subKey === "basicMode") {
                    labelVal = "Standard";
                }
                if (this.isGuid(subKey)) {
                    labelVal =
                        _.get(this.objA, `capture.${subKey}.commandSetName`) ||
                        _.get(this.objB, `capture.${subKey}.commandSetName`) ||
                        _.get(this._model._gameEditor._commandSetMap, subKey, "Command Set");
                }

                const subDiffClass = this.getDiffClass(
                    this.objA[key][subKey],
                    this.objB[key][subKey]
                );

                const isCommandSet =
                    typeof this.objA[key][subKey] === "object" &&
                    !_.isArray(this.objA[key][subKey]) &&
                    typeof this.objB[key][subKey] === "object" &&
                    !_.isArray(this.objB[key][subKey]);

                if (isCommandSet) {
                    if (
                        this._isEmptyCommandSet(this.objA[key][subKey]) &&
                        this._isEmptyCommandSet(this.objB[key][subKey])
                    ) {
                        continue;
                    }
                }

                const subNode = this.createTreeNode(
                    labelVal,
                    `${subDiffClass} ${subKey === "basicMode" ? "basic-node" : ""}`,
                    subKey === "basicMode" ? "node" : undefined,
                    `${subKey}`,
                    "folder"
                );

                if (
                    Array.isArray(this.objA[key][subKey]) ||
                    Array.isArray(this.objB[key][subKey])
                ) {
                    const subTree = this.buildSubTree(
                        this.objA[key][subKey],
                        this.objB[key][subKey],
                        subKey,
                        subNode
                    );
                    subNode.appendChild(subTree);
                } else if (
                    typeof this.objA[key][subKey] === "object" ||
                    typeof this.objB[key][subKey] === "object"
                ) {
                    const subSubTree = this.buildSubTree(
                        _.get(this.objA, `${key}.${subKey}`, undefined),
                        _.get(this.objB, `${key}.${subKey}`, undefined),
                        subKey,
                        subNode
                    );
                    subNode.appendChild(subSubTree);
                }

                treeNode.appendChild(subNode);
            }
        }

        return treeNode;
    }

    buildSubTree(subObject1, subObject2, subKey, subNode) {
        const subTreeContainer = document.createElement("div");

        if (Array.isArray(subObject1) || Array.isArray(subObject2)) {
            for (
                let i = 0;
                i < Math.max(_.get(subObject1, "length", 0), _.get(subObject2, "length", 0));
                i++
            ) {
                const item1 = _.get(subObject1, i);
                const item2 = _.get(subObject2, i);

                const diffClass = this.getDiffClass(item1, item2);
                if (item1 ? item1.command : item2.command) {
                    const subNode = this.createTreeNode(
                        item1 ? item1.command : item2.command,
                        diffClass,
                        undefined,
                        undefined,
                        "folder"
                    );
                    subTreeContainer.appendChild(subNode);
                }
            }
        } else if (typeof subObject1 === "object" || typeof subObject2 === "object") {
            const subKeys = new Set([..._.keys(subObject1), ..._.keys(subObject2)]);

            for (const subSubKey of subKeys) {
                if (
                    !(
                        _.isEmpty(_.get(this.objA, `capture.${subKey}.${subSubKey}`)) &&
                        _.isEmpty(_.get(this.objB, `capture.${subKey}.${subSubKey}`))
                    )
                ) {
                    let selector = "";
                    if (subSubKey === "cliCommands") {
                        selector = "command";
                    } else if (subSubKey === "conceptItems") {
                        selector = "conceptItemName";
                    } else if (subSubKey === "getUrls") {
                        selector = "getUrl";
                    } else if (subSubKey === "restSyncItems") {
                        selector = "restSyncItemName";
                    }

                    if (
                        (!_.isEmpty(_.get(subObject1, subSubKey, [])) &&
                            _.isArray(_.get(subObject1, subSubKey, []))) ||
                        (!_.isEmpty(_.get(subObject2, subSubKey, [])) &&
                            _.isArray(_.get(subObject2, subSubKey, [])))
                    ) {
                        const subSubTreeContainer = document.createElement("div");
                        subSubTreeContainer.classList.add("node-class");

                        _.merge(
                            [],
                            _.get(subObject1, subSubKey, []),
                            _.get(subObject2, subSubKey, [])
                        ).forEach((item, i) => {
                            const diffClass = this.getDiffClass(
                                _.get(subObject1, `${subSubKey}.${i}`, undefined),
                                _.get(subObject2, `${subSubKey}.${i}`, undefined),
                                selector
                            );
                            const subNode = this.createTreeNode(
                                item[selector] || subSubKey,
                                diffClass,
                                "node",
                                `${subKey}.${subSubKey}.${i}`,
                                "node"
                            );
                            subSubTreeContainer.appendChild(subNode);
                        });
                        subNode.appendChild(subSubTreeContainer);
                    }
                }
            }
        }

        return subTreeContainer;
    }

    getDiffClass(item1, item2, key) {
        if (["command", "conceptItemName", "getUrl", "restSyncItemName"].indexOf(key) > -1) {
            if ((!item1 || !item1.responseStr) && (!item2 || !item2.responseStr)) {
                return "";
            }
            if (!item1 || !item1.responseStr) {
                return "added";
            }
            if (!item2 || !item2.responseStr) {
                return "removed";
            }
            return item1.responseStr === item2.responseStr ? "" : "updated";
            // compare for JSON
            // return JSON.stringify(item1) === JSON.stringify(item2) ? "" : "updated";
        }

        if (!item1 && !item2) {
            return "";
        }
        if (!item1) {
            return "added";
        }
        if (!item2) {
            return "removed";
        }
        return JSON.stringify(item1) === JSON.stringify(item2) ? "" : "updated";
    }

    _hideShowJSONButton() {
        const obj1ConfObj =
            this._model._selectedPath === ""
                ? _.get(this.objA, "capture", {})
                : _.get(this.objA, "capture." + this._model._selectedPath);
        const obj2ConfObj =
            this._model._selectedPath === ""
                ? _.get(this.objB, "capture", {})
                : _.get(this.objB, "capture." + this._model._selectedPath);

        if (
            (_.get(obj1ConfObj, "isObject", false) || _.isEmpty(obj1ConfObj)) &&
            (_.isEmpty(obj2ConfObj) || _.get(obj2ConfObj, "isObject", false))
        ) {
            this._model._gameEditor.showViewAction("switchView");
        } else {
            this._model._gameEditor.hideViewAction("switchView");
            this._model._jsonDiff = false;
            this._model._isJsonView = false;
        }
    }

    _updateConfiguration(path = undefined) {
        const model = this._model;
        model._selectedPath = path;

        const obj1ConfObj = path === "" ? this.objA.capture : _.get(this.objA.capture, path);
        const obj2ConfObj = path === "" ? this.objB.capture : _.get(this.objB.capture, path);

        const splitPath = path.split(".");
        const commandSetName =
            _.get(this.objA, "capture." + splitPath[0] + ".commandSetName", false) ||
            _.get(this.objB, "capture." + splitPath[0] + ".commandSetName", false) ||
            _.get(this._model._gameEditor._commandSetMap, splitPath[0], "Command Set");

        model._modalUserFeedback.displayLoading();
        this._hideShowJSONButton();

        const viewType = this._model._jsonDiff ? "responseObj" : "responseStr";

        model._confA = this._generateConfigString(
            obj1ConfObj,
            viewType,
            model._selectedPath,
            commandSetName
        );
        model._confB = this._generateConfigString(
            obj2ConfObj,
            viewType,
            model._selectedPath,
            commandSetName
        );

        if (!this._model._jsonDiff) {
            model._confA = _.trim(model._confA);
            model._confB = _.trim(model._confB);
        }

        if (_.isEqual(model._confA, model._confB)) {
            this._showDeviceIdenticalMessageDisplay();
            if (!this._model._isDiffReady) {
                this._model._isDiffReady = true;
                this._model._modalUserFeedback.hideDisplayed();
            }
        }

        if (this._model._jsonDiff) {
            this._model._generateJSONDiffString();
        } else {
            this._model._generateDiffString();
        }
    }

    _generateConfigString(configObj, viewType, path, commandSetName) {
        if (_.isArray(configObj)) {
            return configObj.reduce((acc, item) => {
                if (_.get(item, viewType, false)) {
                    acc += this._getHeading(true);
                }
                acc += _.get(item, viewType, "") + "\n";
                return acc;
            }, "");
        } else if (this.isGuid(path)) {
            return this._getCommandSetConfig(configObj, viewType);
        } else if (path === "") {
            return this._getRootConfig(configObj, viewType);
        } else {
            return this._getSubConfig(configObj, viewType, path, commandSetName);
        }
    }

    _getSubConfig(configObj, viewType, path, commandSetName) {
        let confStr = "";

        let label = "";
        let valueObj = "";
        if (!_.isUndefined(_.get(configObj, `conceptItemName`))) {
            label = "Concept Item";
            valueObj = _.get(configObj, `conceptItemName`);
        } else if (!_.isUndefined(_.get(configObj, `restSyncItemName`))) {
            label = "Rest Data Sync Items";
            valueObj = _.get(configObj, `restSyncItemName`);
        } else if (!_.isUndefined(_.get(configObj, `getUrl`))) {
            label = "Raw HTTP GET requests";
            valueObj = _.get(configObj, `getUrl`);
        } else if (!_.isUndefined(_.get(configObj, `command`))) {
            label = "CLI Command";
            valueObj = _.get(configObj, `command`);
        } else {
            label = "Standard";
            valueObj = "Standard Configuration";
        }

        if (_.get(configObj, viewType, false) && viewType === "responseStr") {
            if (label === "Standard") {
                confStr += this._getHeading(true);
            } else {
                confStr += this._getHeading(false, commandSetName, label, valueObj);
            }
        }

        if (this._model._jsonDiff) {
            confStr = _.get(configObj, viewType, "");
        } else {
            confStr += _.get(configObj, viewType, "");
        }

        return confStr;
    }

    _getCommandSetConfig(configObj, viewType) {
        let confStr = "";
        if (_.isObject(configObj)) {
            Object.entries(configObj || {}).forEach(([lab, val]) => {
                if (!_.isEmpty(val)) {
                    let label = "";
                    let valueObj = "";
                    if (lab === "cliCommands") {
                        label = "CLI Command";
                        valueObj = "command";
                    } else if (lab === "conceptItems") {
                        label = "Concept Item";
                        valueObj = "conceptItemName";
                    } else if (lab === "getUrls") {
                        label = "Raw HTTP GET request";
                        valueObj = "getUrl";
                    } else if (lab === "restSyncItems") {
                        label = "Rest Data Sync Item";
                        valueObj = "restSyncItemName";
                    }

                    if (_.isArray(val)) {
                        val.forEach((item) => {
                            const commandSetName =
                                _.get(configObj, "commandSetName", false) ||
                                _.get(
                                    this._model._gameEditor._commandSetMap,
                                    configObj,
                                    "Command Set"
                                );

                            confStr += this._getHeading(
                                false,
                                commandSetName,
                                label,
                                item[valueObj]
                            );
                            confStr += _.get(item, viewType, "");
                        });
                    }
                }
            });
        }
        return confStr;
    }

    _getRootConfig(configObj, viewType) {
        let confStr = "";

        // Config for Object 1
        if (configObj && _.isObject(configObj)) {
            if (_.get(configObj, "basicMode")) {
                // Standard Config
                confStr += this._getHeading(true);
                configObj.basicMode.forEach((i) => {
                    confStr += _.get(i, viewType);
                });
            }
            Object.entries(configObj).forEach(([labCs, valCs]) => {
                if (labCs !== "basicMode") {
                    if (this.isGuid(labCs)) {
                        //Command Set Name

                        Object.entries(valCs || {}).forEach(([lab, val]) => {
                            if (!_.isEmpty(val)) {
                                let label = "";
                                let valueObj = "";
                                if (lab === "cliCommands") {
                                    label = "CLI Command";
                                    valueObj = "command";
                                } else if (lab === "conceptItems") {
                                    label = "Concept Item";
                                    valueObj = "conceptItemName";
                                } else if (lab === "getUrls") {
                                    label = "Raw HTTP GET request";
                                    valueObj = "getUrl";
                                } else if (lab === "restSyncItems") {
                                    label = "Rest Data Sync Item";
                                    valueObj = "restSyncItemName";
                                }

                                if (_.isArray(val)) {
                                    val.forEach((item) => {
                                        const commandSetName =
                                            _.get(valCs, "commandSetName", false) ||
                                            _.get(
                                                this._model._gameEditor._commandSetMap,
                                                labCs,
                                                "Command Set"
                                            );
                                        confStr += this._getHeading(
                                            false,
                                            commandSetName,
                                            label,
                                            item[valueObj]
                                        );
                                        confStr += _.get(item, viewType, "");
                                    });
                                }
                            }
                        });
                    }
                }
            });
        }

        return confStr;
    }

    isGuid(str) {
        const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return guidPattern.test(str);
    }

    _setSelection(path) {
        this._model._selectedPath = path;
        const treeNodes = this._tree.querySelectorAll(".tree-node");
        treeNodes.forEach((node) => {
            node.classList.remove("selected");
        });
        const selectedNode = this._tree.querySelector(".tree-node[data-path='" + path + "']");
        if (selectedNode) {
            selectedNode.classList.add("selected");
        }
    }

    _getHeading(standard, commandSetName, label, valueObj) {
        let str = "";
        if (standard) {
            str +=
                "**************************************************************************************\n";
            str += "Standard Configuration";
            str +=
                "\n**************************************************************************************\n\n";
        } else {
            str += "\n\n\n";

            str +=
                "**************************************************************************************\n";
            str += "Command Set : " + commandSetName;
            str += "\n" + label + " : " + valueObj;
            str +=
                "\n**************************************************************************************\n\n";
        }

        return str;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = CompareViewRenderer;
